import React from 'react';
import { Divider, Icon, Image, SemanticICONS } from 'semantic-ui-react';
import config from '@config/config';

import Header, { HeaderContent } from '@modules/common/components/Header';

const RACHEL_IMG = require('../../../images/rachel.png');

type Props = {
  withFace?: boolean;
  icon?: SemanticICONS;
  children: React.ReactNode;
  userLabel: string;
};

const UserFormHeader = ({ userLabel, children, withFace = true, icon }: Props) => {
  return (
    <div style={{ display: 'flex', padding: '2rem' }}>
      {withFace && <Image wrapped size="small" src={RACHEL_IMG} />}

      <div style={{ width: '100%', marginTop: '0px', padding: '10px' }}>
        <Header as="h2" style={{ margin: '0px' }}>
          {icon && <Icon name={icon} />}
          <HeaderContent>{userLabel}</HeaderContent>
        </Header>
        <Divider />
        {children}
      </div>
    </div>
  );
};

export default UserFormHeader;
